// extracted by mini-css-extract-plugin
module.exports = {"msgLimit":"CreateSMS_msgLimit__3Ggz3","patientName":"CreateSMS_patientName__2K24j"};